/* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
export function unique(value: any, index: any, self: any) {
  return self.indexOf(value) === index;
}
